<div class="relative max-w-lg w-full max-h-[90vh] p-6 md:p-8 overflow-y-auto antialiased surface-card shadow-lg animate-fadeIn selection:bg-primary/20 scrollbar-thin scrollbar-thumb-border-strong scroll-smooth">
    
    <div class="absolute right-0 top-0 w-24 h-32 bg-gradient-to-bl from-primary/10 to-transparent pointer-events-none rounded-tr-3xl"></div>

    <div class="flex items-center justify-between mb-6 pb-4 border-b border-dashed border-border-subtle">
        <div class="flex items-center gap-3">
            <div class="w-10 h-10 flex items-center justify-center shrink-0 bg-primary/10 border border-primary/20 rounded-xl text-primary shadow-sm">
                <i class="fa-solid fa-calendar-day text-sm"></i>
            </div>
            <div>
                <h4 class="font-mono text-[10px] font-black uppercase tracking-widest text-text-muted">{{ 'scheduleViewing.conciergeService' | translate }}</h4>
                <h3 class="text-base sm:text-lg font-black text-text-primary tracking-tight mt-0.5">{{ 'scheduleViewing.title' | translate }}</h3>
            </div>
        </div>

        <button type="button" (click)="onClose()" title="Close Modal"
            class="p-2.5 flex items-center justify-center shrink-0 border border-transparent hover:border-border-subtle hover:bg-surface-hover text-text-muted hover:text-text-primary rounded-xl cursor-pointer transition-all active:scale-90">
            <i class="fa-solid fa-xmark text-sm block"></i>
        </button>
    </div>

    <form (ngSubmit)="onSubmit()" #viewingForm="ngForm" class="space-y-5">

        @if (errorMessage) {
            <div class="p-4 flex items-start gap-2.5 bg-error/10 border border-error/20 rounded-2xl text-xs font-semibold text-error animate-fadeIn">
                <i class="fa-solid fa-circle-exclamation text-sm shrink-0 mt-0.5 animate-pulse"></i>
                <span class="leading-relaxed">{{ errorMessage }}</span>
            </div>
        }

        @if (successMessage) {
            <div class="p-4 space-y-2 bg-success/10 border border-success/20 rounded-2xl text-xs font-semibold text-success animate-fadeIn">
                <div class="flex items-start gap-2.5">
                    <i class="fa-solid fa-circle-check text-sm shrink-0 mt-0.5 text-success"></i>
                    <span class="leading-relaxed">{{ successMessage }}</span>
                </div>

                @if (createdViewingStatus || createdViewingId) {
                    <div class="pt-2 grid grid-cols-2 gap-2 border-t border-success/20 font-mono text-[10px] text-success uppercase tracking-wider">
                        @if (createdViewingStatus) {
                            <div class="truncate">{{ 'scheduleViewing.status' | translate }}: <span class="font-black text-success">{{ createdViewingStatus }}</span></div>
                        }
                        @if (createdViewingId) {
                            <div class="text-right truncate" [title]="createdViewingId">{{ 'scheduleViewing.viewingId' | translate }}: <span class="font-black text-success">#{{ createdViewingId }}</span></div>
                        }
                    </div>
                }
            </div>
        }

        <div class="space-y-4">
            
            <div class="space-y-1.5">
                <label class="inline-flex items-center gap-1.5 font-mono text-[11px] font-black uppercase tracking-wider text-text-muted">
                    <i class="fa-solid fa-user-tie text-primary text-[10px]"></i>
                    <span>{{ 'scheduleViewing.fullName' | translate }}</span>
                </label>
                <input type="text" name="name" [(ngModel)]="formData.name" required
                    [placeholder]="'scheduleViewing.fullNamePlaceholder' | translate"
                    class="w-full px-4 py-3 bg-bg-secondary/50 hover:bg-surface-hover border border-border focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 text-sm font-semibold text-text-primary placeholder-text-muted rounded-2xl outline-none transition-all duration-200">
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div class="space-y-1.5">
                    <label class="inline-flex items-center gap-1.5 font-mono text-[11px] font-black uppercase tracking-wider text-text-muted">
                        <i class="fa-solid fa-phone-volume text-primary text-[10px]"></i>
                        <span>{{ 'scheduleViewing.phoneNumber' | translate }}</span>
                    </label>
                    <input type="tel" name="phone" [(ngModel)]="formData.phone" required
                        placeholder="+20 1XX XXX XXXX"
                        class="w-full px-4 py-3 bg-bg-secondary/50 hover:bg-surface-hover border border-border focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 text-sm font-semibold text-text-primary placeholder-text-muted rounded-2xl outline-none transition-all duration-200">
                </div>
                
                <div class="space-y-1.5">
                    <label class="inline-flex items-center gap-1.5 font-mono text-[11px] font-black uppercase tracking-wider text-text-muted">
                        <i class="fa-solid fa-envelope-open text-primary text-[10px]"></i>
                        <span>{{ 'scheduleViewing.emailAddress' | translate }}</span>
                    </label>
                    <input type="email" name="email" [(ngModel)]="formData.email" required
                        placeholder="your.email@domain.com"
                        class="w-full px-4 py-3 bg-bg-secondary/50 hover:bg-surface-hover border border-border focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 text-sm font-semibold text-text-primary placeholder-text-muted rounded-2xl outline-none transition-all duration-200">
                </div>
            </div>

            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div class="space-y-1.5">
                    <label class="inline-flex items-center gap-1.5 font-mono text-[11px] font-black uppercase tracking-wider text-text-muted">
                        <i class="fa-solid fa-calendar-day text-primary text-[10px]"></i>
                        <span>{{ 'scheduleViewing.preferredDate' | translate }}</span>
                    </label>
                    <input type="date" name="date" [(ngModel)]="formData.date" [min]="minDate" required
                        class="w-full px-4 py-3 bg-bg-secondary/50 hover:bg-surface-hover border border-border focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 text-sm font-semibold text-text-primary rounded-2xl outline-none cursor-pointer transition-all duration-200">
                </div>

                <div class="space-y-1.5">
                    <label class="inline-flex items-center gap-1.5 font-mono text-[11px] font-black uppercase tracking-wider text-text-muted">
                        <i class="fa-solid fa-clock text-primary text-[10px]"></i>
                        <span>{{ 'scheduleViewing.preferredTime' | translate }}</span>
                    </label>
                    <div class="relative">
                        <select name="time" [(ngModel)]="formData.time" required
                            class="w-full px-4 py-3 bg-bg-secondary/50 hover:bg-surface-hover border border-border focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 text-sm font-bold text-text-primary rounded-2xl outline-none appearance-none cursor-pointer transition-all duration-200">
                            <option value="" class="bg-bg-secondary">{{ 'scheduleViewing.selectTimeSlot' | translate }}</option>
                            @for (slot of timeSlots; track slot.value) {
                                <option [value]="slot.value" class="bg-bg-secondary">{{ slot.label }}</option>
                            }
                        </select>
                        <div class="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-text-muted text-xs">
                            <i class="fa-solid fa-chevron-down"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="space-y-1.5">
                <label class="inline-flex items-center gap-1.5 font-mono text-[11px] font-black uppercase tracking-wider text-text-muted">
                    <i class="fa-solid fa-paragraph text-primary text-[10px]"></i>
                    <span>{{ 'scheduleViewing.specialRequirements' | translate }} <span class="font-sans font-medium lowercase text-text-secondary">({{ 'scheduleViewing.optional' | translate }})</span></span>
                </label>
                <textarea name="notes" [(ngModel)]="formData.notes" rows="3"
                    [placeholder]="'scheduleViewing.specialRequirementsPlaceholder' | translate"
                    class="w-full px-4 py-3 bg-bg-secondary/50 hover:bg-surface-hover border border-border focus:bg-bg-secondary focus:border-primary focus:ring-4 focus:ring-primary/10 text-sm font-semibold text-text-primary placeholder-text-muted rounded-2xl outline-none resize-none transition-all duration-200"></textarea>
            </div>
        </div>

        <label class="p-4 flex items-start gap-3 bg-warning/5 hover:bg-warning/10 border border-warning/20 hover:border-warning/35 rounded-2xl text-xs font-medium text-warning cursor-pointer transition-all duration-200 select-none group">
            <input type="checkbox" name="agreedToPolicy" [(ngModel)]="agreedToPolicy" required
                class="sr-only peer" id="verificationPolicyCheckbox" />
            <div class="w-6 h-6 flex items-center justify-center shrink-0 mt-0.5 rounded-lg border-2 transition-all duration-200 shadow-sm"
                [ngClass]="agreedToPolicy ? 'bg-warning border-warning text-white' : 'border-warning/40 bg-bg-secondary group-hover:border-warning text-transparent'">
                <i class="fa-solid fa-check text-xs transition-transform duration-200"
                    [class.scale-100]="agreedToPolicy"
                    [class.scale-0]="!agreedToPolicy"></i>
            </div>
            <div class="leading-relaxed flex-1">
                <strong class="font-mono text-[10px] font-black uppercase tracking-wider text-warning block mb-1">
                    {{ 'scheduleViewing.verificationPolicyTitle' | translate }}
                </strong>
                <span class="text-text-secondary">
                    {{ 'scheduleViewing.verificationPolicyDesc' | translate }}
                </span>
            </div>
        </label>

        <div class="pt-5 mt-5 flex gap-3 border-t border-dashed border-border-subtle">
            <button type="button" (click)="onClose()"
                class="flex-1 px-5 py-3.5 bg-bg-secondary hover:bg-surface-hover border border-border-subtle hover:border-border font-mono text-xs font-black uppercase tracking-widest text-text-secondary hover:text-text-primary rounded-2xl cursor-pointer transition-all active:scale-[0.98]">
                {{ 'common.cancel' | translate }}
            </button>

            <button type="submit" [disabled]="!viewingForm.valid || isSubmitting"
                class="btn-primary flex-1 px-5 py-3.5 flex items-center justify-center gap-2 font-mono text-xs font-black uppercase tracking-widest rounded-2xl disabled:opacity-40 disabled:cursor-not-allowed disabled:shadow-none cursor-pointer transition-all duration-300 active:scale-[0.98]">
                @if (isSubmitting) {
                    <i class="fa-solid fa-spinner-third fa-spin text-sm"></i>
                    <span>{{ 'scheduleViewing.submitting' | translate }}</span>
                } @else {
                    <i class="fa-solid fa-calendar-check text-[11px]"></i>
                    <span>{{ 'scheduleViewing.confirmBooking' | translate }}</span>
                }
            </button>
        </div>

    </form>
</div>